import { GlobalHelper } from '../../helpers/GlobalHelpers';

export interface ToastProps {
  message: string;
}

export const PruToast = (payload: ToastProps) => {
  const { show, hide } = GlobalHelper.getGlobalToastRef();
  show &&
    show({
      message: payload.message,
    });
  return { hide };
};
